import { LocalVideoTrack } from 'twilio-video';
import { useCallback, useState } from 'react';
import { useVideoContext } from './use-video-context';

export const useLocalVideoToggle = () => {
  const { room, localTracks, getLocalVideoTrack, removeLocalVideoTrack, onError, toggleVideoFilter } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const videoTrack = localTracks.find(track => track.name.includes('camera')) as LocalVideoTrack;
  const [ isPublishing, setIspublishing ] = useState(false);

  const toggleVideoEnabled = useCallback(() => {

    if (!isPublishing) {
      if (videoTrack) {
        const localTrackPublication = localParticipant?.unpublishTrack(videoTrack);
        // TODO: remove when SDK implements this event. See: https://issues.corp.twilio.com/browse/JSDK-2592
        // TODO: likely we want to hook onto the trackUnpub on the local partisipant to make this a global action rather than patched in 3 places

        localParticipant?.emit('trackUnpublished', localTrackPublication);
        removeLocalVideoTrack();
        toggleVideoFilter(true);
      } else {
        setIspublishing(true);
        getLocalVideoTrack()
          .then((track: LocalVideoTrack) => localParticipant?.publishTrack(track, { priority: 'low' }))
          .catch(onError)
          .finally(() => setIspublishing(false));
      }
    }
  }, [ videoTrack, localParticipant, getLocalVideoTrack, isPublishing, onError, removeLocalVideoTrack, toggleVideoFilter ]);

  return [ !!videoTrack, toggleVideoEnabled ] as const;
};
